"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var ResponsiveResizeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ResponsiveResizeComponent, _super);
    function ResponsiveResizeComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.frame = null;
        _this.componentDidResize = _this.componentDidResize.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        return _this;
    }
    ResponsiveResizeComponent.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.handleWindowResize, { capture: false, passive: true });
    };
    ResponsiveResizeComponent.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize, { capture: false, passive: true });
    };
    ResponsiveResizeComponent.prototype.handleWindowResize = function (e) {
        utils_1.caf(this.frame);
        this.frame = utils_1.raf(this.componentDidResize);
    };
    return ResponsiveResizeComponent;
}(React.Component));
exports.default = ResponsiveResizeComponent;
